
export interface AbstractGetPeriodicBackupStatusOperationResult {
    isSharded: boolean;
}